(function () {
  'use strict';

  /* ---------- Delivery timeline ---------- */
  function addDays(date, days, skipWeekends) {
    var d = new Date(date.getTime());
    if (!skipWeekends) {
      d.setDate(d.getDate() + days);
      return d;
    }
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }

  function formatDate(d, locale) {
    try {
      return d.toLocaleDateString(locale, { month: 'short', day: 'numeric' });
    } catch (e) {
      return d.toDateString().slice(4, 10);
    }
  }

  function initDelivery(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tw-delivery]').forEach(function (wrap) {
      var skip = wrap.dataset.skipWeekends === 'true';
      var locale = wrap.dataset.locale || document.documentElement.lang || 'en-US';
      var sep = wrap.dataset.separator || ' - ';
      var today = new Date();
      wrap.querySelectorAll('[data-min]').forEach(function (el) {
        var min = parseInt(el.dataset.min, 10) || 0;
        var max = parseInt(el.dataset.max, 10);
        if (isNaN(max) || max < min) max = min;
        var from = formatDate(addDays(today, min, skip), locale);
        var to = formatDate(addDays(today, max, skip), locale);
        el.textContent = min === max ? from : from + sep + to;
      });
    });
  }

  /* ---------- Mini review slider ---------- */
  function initSliders(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-tw-rslider]').forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = 'true';
      var slides = slider.querySelectorAll('.tw-rslider__slide');
      var dots = slider.querySelectorAll('.tw-rslider__dot');
      if (slides.length < 2) return;
      var index = 0;
      var interval = parseInt(slider.dataset.interval, 10) || 5000;
      var timer;

      function go(i) {
        slides[index].classList.remove('is-active');
        if (dots[index]) dots[index].classList.remove('is-active');
        index = (i + slides.length) % slides.length;
        slides[index].classList.add('is-active');
        if (dots[index]) dots[index].classList.add('is-active');
      }

      function start() {
        stop();
        timer = setInterval(function () {
          go(index + 1);
        }, interval);
      }

      function stop() {
        if (timer) clearInterval(timer);
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          go(i);
          start();
        });
      });
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      start();
    });
  }

  /* ---------- Sticky add to cart ---------- */
  function initSticky() {
    var fresh = document.querySelectorAll('[data-tw-sticky]:not([data-ready])');
    if (!fresh.length) return;
    var sticky = fresh[fresh.length - 1];
    sticky.dataset.ready = 'true';

    // Remove bars left over from a previous render (theme editor).
    document.querySelectorAll('body > [data-tw-sticky]').forEach(function (el) {
      if (el !== sticky) el.remove();
    });

    // Move to <body> so it is never clipped by sticky / transformed parents.
    document.body.appendChild(sticky);

    var target = document.getElementById(sticky.dataset.target);
    var mobileOnly = sticky.dataset.mobileOnly === 'true';

    function setVisible(show) {
      if (mobileOnly && window.innerWidth >= 750) show = false;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    if (target && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }).observe(target);
    } else {
      window.addEventListener(
        'scroll',
        function () {
          setVisible(window.scrollY > 700);
        },
        { passive: true }
      );
    }

    var select = sticky.querySelector('.tw-sticky__select');
    var priceEl = sticky.querySelector('.tw-sticky__price');
    var compareEl = sticky.querySelector('.tw-sticky__compare');
    var badgeEl = sticky.querySelector('.tw-sticky__badge');
    var btn = sticky.querySelector('.tw-sticky__btn');
    var btnText = btn ? btn.querySelector('span') : null;

    function syncFromOption(opt) {
      if (!opt) return;
      if (priceEl) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        compareEl.textContent = opt.dataset.compare || '';
        compareEl.hidden = !opt.dataset.compare;
      }
      if (badgeEl) {
        var save = parseInt(opt.dataset.save, 10) || 0;
        badgeEl.hidden = save <= 0;
        badgeEl.textContent = (badgeEl.dataset.prefix || 'SAVE') + ' ' + save + '%';
      }
      if (btn) {
        var available = opt.dataset.available === 'true';
        btn.disabled = !available;
        if (btnText) btnText.textContent = available ? btn.dataset.addText : btn.dataset.soldText;
      }
    }

    if (select) {
      select.addEventListener('change', function () {
        syncFromOption(select.options[select.selectedIndex]);
      });
    }

    if (select && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data && event.data.variant;
        if (!variant) return;
        var opt = select.querySelector('option[value="' + variant.id + '"]');
        if (opt) {
          select.value = String(variant.id);
          syncFromOption(opt);
        }
      });
    }
  }

  /* ---------- Cart reservation timer ---------- */
  var TIMER_KEY = 'tw-cart-timer-end';

  function timerEnd(minutes) {
    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(TIMER_KEY), 10) || 0;
    } catch (e) {}
    if (!end || end <= Date.now()) {
      end = Date.now() + minutes * 60000;
      try {
        sessionStorage.setItem(TIMER_KEY, String(end));
      } catch (e) {}
    }
    return end;
  }

  function tickTimers() {
    var els = document.querySelectorAll('[data-tw-timer]');
    if (!els.length) return;
    var minutes = parseInt(els[0].dataset.minutes, 10) || 10;
    var left = Math.max(0, timerEnd(minutes) - Date.now());
    var m = Math.floor(left / 60000);
    var s = Math.floor((left % 60000) / 1000);
    var text = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    els.forEach(function (el) {
      el.textContent = text;
    });
  }

  function initAll(root) {
    initDelivery(root);
    initSliders(root);
    initSticky();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  tickTimers();
  setInterval(tickTimers, 1000);

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
